// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__1mNCS","landing":"home_landing__27eOS"};